export default __webpack_public_path__ + "static/media/drive.31c21132.svg";